import { render, staticRenderFns } from "./LinkToRecipient.vue?vue&type=template&id=4ac02dc8"
import script from "./LinkToRecipient.vue?vue&type=script&lang=ts"
export * from "./LinkToRecipient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/livingDonors/_locales/LinkToRecipient.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2FLinkToRecipient.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports